<div class="quantity-input"
     [ngClass]="{'justify-content-end': isProduct}">

  <div class="quantity-input_label" *ngIf="isCartItem && !!cartItem.quantityPrice">Quantity:</div>

  <div class="quantity-input_but quantity-input_but_minus">
    <button 
      id="quantity-minus-button"
      class="minus-btn"
      (click)="decreaseQuantity();$event.stopPropagation()"
      [disabled]="decreaseButtonDisabled">-</button>

  </div>
  <div class="quantity-input_text-input">
    <input
      id="quantity-input"
      type="number" 
      [(ngModel)]='modelField'
      (focus)="setOldValue()"
      (change)="updateFromInput()">
  </div>
  <div class="quantity-input_but">
    <button 
      id="quantity-plus-button"
      class="plus-btn"
      (click)="increaseQuantity();$event.stopPropagation()"
      [disabled]="increaseButtonDisabled"
      [title]="increaseButtonDisabled ? 'Maximum quantity allowed reached' : ''">+</button>
  </div>

</div>
